import { useMemo } from 'react'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export function useAppInsights() {
  return useMemo(() => {
    const appInsights = new ApplicationInsights({
      config: {
        connectionString: process.env.NX.NX_APPINSIGHTS_CONN_STR
      }
    })
    appInsights.loadAppInsights()
    appInsights.trackPageView()
    return appInsights
  }, [])
}
